import { createActionCreator, paramsEncode } from '../../../utils';
import request from '../../../utils/request';
import constant from './constant';
import Urls from '../../../../config/index';
import moment from 'moment';

export const createLoadingAction = createActionCreator(constant.loading, loading => loading);
export const createAgentCurveDataAction = createActionCreator(constant.agentCurveData, list => list);
export const createWidthDataAction = createActionCreator(constant.widthData, list => list);
export const createConnectDataAction = createActionCreator(constant.connectData, list => list);
export const createMultiCurveDataAction = createActionCreator(constant.multiCurveData, list => list);
export const createBandwidthDetailAction = createActionCreator(constant.bandwidthDetail, list => list);
export const createAgentSortAction = createActionCreator(constant.agentSort, list => list);
export const createPieDataAction = createActionCreator(constant.pieData, list => list);
export const createSearchAction = createActionCreator(constant.search, o => o);
export const createAgentsAction = createActionCreator(constant.agents, list => list);
export const createAreasAction = createActionCreator(constant.areas, list => list);

let getAgentCurveDataUrl = Urls.AgentConnectUrl.getAgentCurveData;
let getProxyWidthDetailUrl = Urls.AgentConnectUrl.getProxyWidthDetail;

let getSortAgentWidthDetailData = Urls.AgentConnectUrl.getSortAgentWidthDetailData;
let getSizePieDataUrl = Urls.AgentConnectUrl.getSizePieDataUrl;

let partnerUrl = Urls.PartnerUrl;
// 获取合作商
export const getAgentsInfo = () => {
    return async (dispatch, getState) => {
        try {
            let response = await request(partnerUrl.paramList);
            dispatch(createAgentsAction(response.partnerName));
            dispatch(createAreasAction(response.area));
        } catch (e) {
            throw new Error(e);
        }
    }
}

export const getBandwidthDetailSortList = () => {
    return async (dispatch, getState) => {
        try {
            let response ;
            response = await request(getSortAgentWidthDetailData);
            console.log("aaa",response);
            dispatch(createAgentSortAction(response));
        } catch (e) {
            throw new Error(e);
        }
    }
}


export const getBandwidthDetailList = () => {
    return async (dispatch, getState) => {
        try {
            let search = getState().widthAndConnect.search;
            let response ;
            if(search==undefined || Object.keys(search).length==0){
                const today = moment().format('YYYY-MM-DD')
                search = "startDay="+today+"&endDay="+today;
                response = await request(getProxyWidthDetailUrl + search);
            }else{   
                response = await request(getProxyWidthDetailUrl + paramsEncode(Object.assign(search)));
            }
            dispatch(createBandwidthDetailAction(response.proxyWidthDetail));
        } catch (e) {
            throw new Error(e);
        }
    }
}

//获取nolmal模块的列表和两个曲线的数据
export const getAgentQualityList = () => {
    return async (dispatch, getState) => {
        try {
            let search = getState().widthAndConnect.search;
            let response ;
            if(search==undefined || Object.keys(search).length==0){
                const today = moment().format('YYYY-MM-DD')
                search = "startDay="+today+"&endDay="+today;
                response = await request(getAgentCurveDataUrl + search);
            }else{   
                response = await request(getAgentCurveDataUrl + paramsEncode(Object.assign(search)));
            }
            //response.widthData为实时带宽和平均网速的曲线数据
            dispatch(createWidthDataAction(response.widthData));
            dispatch(createConnectDataAction(response.connectData));
            //多条曲线一起展示
            dispatch(createMultiCurveDataAction(response));

        } catch (e) {
            throw new Error(e);
        }
    }
}

export const getPieData = () => {
    return async (dispatch, getState) => {
        try {
            let response ;
            let search = getState().widthAndConnect.search;
            if(search==undefined || Object.keys(search).length==0){
                const today = moment().format('YYYY-MM-DD')
                search = "startDay="+today+"&endDay="+today;
                response = await request(getSizePieDataUrl + search);
            }else{   
                response = await request(getSizePieDataUrl + paramsEncode(Object.assign(search)));
            }
            dispatch(createPieDataAction(response));
        } catch (e) {
            throw new Error(e);
        }
    }
}


//
export const onFieldsChange = (search) => {
    return (dispatch, getState) => {
        dispatch(createSearchAction(search));
    }
}



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/widthAndConnect/action.js